import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Link } from 'components/ui';

function RemoveButton({ creditCard, removeText, showEditButtonFirst, removeCallback }) {
    return (
        <>
            <Link
                aria-label={removeText + ' ' + creditCard.paymentDisplayInfo}
                paddingX={2}
                paddingY={1}
                margin={-2}
                color='blue'
                data-at={Sephora.debug.dataAt('remove_button')}
                onClick={removeCallback(creditCard)}
            >
                {removeText}
            </Link>
            {!showEditButtonFirst && (
                <Box
                    borderLeft={1}
                    marginX={3}
                    borderColor='divider'
                    css={{
                        '&:last-child': {
                            display: 'none'
                        }
                    }}
                />
            )}
        </>
    );
}

export default wrapFunctionalComponent(RemoveButton, 'RemoveButton');
